import React from 'react';

import { StyleContextValue } from './type';

const initialValue: StyleContextValue = {};

const StyleContext = React.createContext(initialValue);

export default StyleContext;
